import { testPrintBase64String } from './constants'
import PrinterIcon from './parts/PrinterIcon'
import { ConnectionSupport } from '@/features/print/connectionSupport'
import { PrinterError } from '@/features/print/errors'
import { logger } from '@/features/print/logger'
import { AnyConnectionOptions } from '@/features/print/types'
import { printData } from '@/features/print/utils/printData'
import { showAlert } from '@/features/settings/utils/showAlert'
import Button from '@/features/ui/buttons/components/Button'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface TestPrintButtonProps {
    connectionOptions: AnyConnectionOptions
}

const TestPrintButton: FC<TestPrintButtonProps> = ({ connectionOptions }) => {
    const { t } = useTranslation()

    const [isPrinting, setIsPrinting] = useState(false)

    const handlePress = async () => {
        setIsPrinting(true)

        try {
            await printData(testPrintBase64String, connectionOptions)
        } catch (e) {
            if (e instanceof PrinterError) {
                showAlert(
                    t('settings.printers.printerConfiguration.testPrint.failure', { code: e.code })
                )
            } else {
                logger.errorOnly(e)
                showAlert(t('unexpectedError'))
            }
        } finally {
            setIsPrinting(false)
        }
    }

    return (
        <Button
            disabled={
                isPrinting || !ConnectionSupport.isSupportedConnectionType(connectionOptions.type)
            }
            onPress={handlePress}
            color="secondary"
            FrontIcon={PrinterIcon}
            style={{ justifyContent: 'center' }}
        >
            {t('settings.printers.printerConfiguration.testPrint.label').toUpperCase()}
        </Button>
    )
}

export default TestPrintButton
